import { useEffect, useState } from "react";
import { isAdminRole, UserRole } from "../../app/userSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { clearSharedAlert, SharedAlert } from "../../app/siteSlice";
import AlertMessage from "../../components/AlertMessage";
import BroadcastAlerts from "../../components/BroadcastAlerts";
import AdminHome from "./AdminHome";
import TeacherHome from "./TeacherHome";
import StudentHome from "./StudentHome";

export default function Home() {
	const dispatch = useAppDispatch();
	const { firstName, lastName, course, role, isTeachersWriterAccount } = useAppSelector(
		(state) => state.user
	);
	const sharedAlert = useAppSelector((state) => state.site.sharedAlert);

	const [alerts, setAlerts] = useState<Record<number, string>>();
	const [lastMessage, setLastMessage] = useState<SharedAlert>();

	const isAdmin = isAdminRole(role);

	useEffect(() => {
		if (sharedAlert) {
			setLastMessage(sharedAlert);
			dispatch(clearSharedAlert());
		}
	}, [sharedAlert]);

	return (
		<>
			<BroadcastAlerts className="w-full mb-8" alerts={alerts} />

			{lastMessage && (
				<AlertMessage
					className="mb-8"
					type={lastMessage.level}
					message={lastMessage.message}
					showIcon={lastMessage.showIcon}
					onClear={() => setLastMessage(undefined)}
				/>
			)}

			<section className="mb-8">
				<h1>{course?.name}</h1>
				<p className="mt-4">
					Welcome, {firstName} {lastName}
					{isTeachersWriterAccount ? " (Student)" : ""}! Use the tabs at the top of the
					screen to{" "}
					{role == UserRole.Writer
						? "write practice essays, review essays written by your peers, take lessons to improve your understanding of writing, or view your reports."
						: "create writing assignments, review completed peer reviews, assign lessons, view class reports, and manage your course."}{" "}
					To change your course, click the course name.
				</p>
			</section>

			{role == UserRole.Writer && <StudentHome setAlerts={setAlerts} />}
			{role == UserRole.Proctor && <TeacherHome setAlerts={setAlerts} />}
			{isAdmin && <AdminHome />}
		</>
	);
}
